import "./index.css";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";

const root = ReactDOM.createRoot(
  document.querySelector("#root") as HTMLElement,
);

root.render(<App />);
